import { whatIsContent } from '@/mocks/seoContent';

export default function WhatIsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50" id="what-is">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            {whatIsContent.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-3xl mx-auto leading-relaxed">
            {whatIsContent.description}
          </p>
        </div>

        <div className="overflow-x-auto rounded-2xl border border-background-200/60 bg-background-50">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-background-100">
                <th className="px-4 md:px-6 py-3 md:py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">
                  Feature
                </th>
                <th className="px-4 md:px-6 py-3 md:py-4 text-sm font-semibold text-foreground-600 whitespace-nowrap">
                  Traditional Searching
                </th>
                <th className="px-4 md:px-6 py-3 md:py-4 text-sm font-semibold text-primary-600 whitespace-nowrap">
                  Sugargoo Spreadsheet
                </th>
              </tr>
            </thead>
            <tbody>
              {whatIsContent.comparisonRows.map((row, idx) => (
                <tr
                  key={row.feature}
                  className={`border-t border-background-100 ${
                    idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                  }`}
                >
                  <td className="px-4 md:px-6 py-3 md:py-4 text-sm font-medium text-foreground-800 whitespace-nowrap">
                    {row.feature}
                  </td>
                  <td className="px-4 md:px-6 py-3 md:py-4 text-sm text-foreground-500">
                    {row.traditional}
                  </td>
                  <td className="px-4 md:px-6 py-3 md:py-4 text-sm font-medium text-primary-700">
                    {row.spreadsheet}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}